import React from 'react';

const SVGRecipeCard = props => {
  return (
    <div className="svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 19">
        <title>Recipe Card</title>
        <path d="M24,18.4H0v-16h3.4L4,0h7.2l0.6,2.4H24V18.4z M1,17.4h22v-14H11L10.4,1H4.8L4.2,3.4H1V17.4z M20.9,6.3H2.3v1 h18.6V6.3z M20.9,8.7H2.3v1h18.6V8.7z M20.9,11.1H2.3v1h18.6V11.1z M14.8,13.5h-12v1h12V13.5z" />
      </svg>
    </div>
  );
};

export default SVGRecipeCard;



// WEBPACK FOOTER //
// ./src/svg/RecipeCard.js